import { useQuery, useMutation, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { Get } from "../config/api/get";
import { Post } from "../config/api/post";
import { useSelector } from "react-redux";
import { HOLIDAY } from "../config/constants";

const HOLIDAY_KEY = ["holidays"];

export const useGetAllHolidays = () => {
  const token = useSelector((state) => state.user.userToken);
  return useQuery({
    queryKey: HOLIDAY_KEY,
    queryFn: async () => {
      const { data } = await Get(HOLIDAY.getAllHolidays, token);
      const list = data?.holidays || [];
      return list.sort((a, b) => new Date(a.date) - new Date(b.date));
    },
    enabled: !!token,
    placeholderData: keepPreviousData,
  });
};

export const useAddHoliday = () => {
  const queryClient = useQueryClient();
  const token = useSelector((state) => state.user.userToken);
  return useMutation({
    mutationFn: async (payload) => {
      const response = await Post(HOLIDAY.addHoliday, payload, token);
      if (response?.data?.status) return response.data;
      throw new Error(response?.data?.message || "Failed to add holiday");
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HOLIDAY_KEY }),
  });
};

export const useUpdateHoliday = () => {
  const queryClient = useQueryClient();
  const token = useSelector((state) => state.user.userToken);
  return useMutation({
    mutationFn: async ({ id, ...payload }) => {
      const response = await Post(HOLIDAY.updateHoliday + id, payload, token);
      if (response?.data?.status !== false) return response.data;
      throw new Error(response?.data?.message || "Failed to update holiday");
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HOLIDAY_KEY }),
  });
};

export const useDeleteHoliday = () => {
  const queryClient = useQueryClient();
  const token = useSelector((state) => state.user.userToken);
  return useMutation({
    mutationFn: async (id) => {
      const response = await Post(HOLIDAY.deleteHoliday + id, {}, token);
      if (response?.data?.status !== false) return response.data;
      throw new Error(response?.data?.message || "Failed to delete holiday");
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HOLIDAY_KEY }),
  });
};
